import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { media } from '@elseu/sdu-titan';
import { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useGreaterThan } from '../../utilities/useGreaterThan/useGreaterThan.js';
import { NavigationColumns } from './NavigationColumns.js';
import { NavigationMain } from './NavigationMain.js';
import { NavigationMobile } from './NavigationMobile.js';
import { NavigationTop } from './NavigationTop.js';

/**
 * The styled component for the Navigation
 */
var StyledNavigation = styled.nav(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    width: 100%;\n    background-color: ", ";\n    padding: ", ";\n    border-bottom: 1px solid ", ";\n\n    ", "\n  "], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    width: 100%;\n    background-color: ", ";\n    padding: ", ";\n    border-bottom: 1px solid ", ";\n\n    ", "\n  "])), theme.designTokens.colors.grey0, theme.spacing[3], theme.designTokens.colors.grey30, media.greaterThan('s')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      border-bottom: none;\n    "], ["\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      border-bottom: none;\n    "]))));
});
/**
 * The Navigation component
 *
 * @param {NavigationProps} props - The props for the Navigation component.
 * @returns {JSX.Element} The Navigation component.
 */
var Navigation = function (_a) {
  var main = _a.main,
    top = _a.top,
    logo = _a.logo,
    shouldCloseMenu = _a.shouldCloseMenu,
    search = _a.search;
  var _b = useState(null),
    openMenuIndex = _b[0],
    setOpenMenuIndex = _b[1];
  var _c = useState(),
    hoverTimeout = _c[0],
    setHoverTimeout = _c[1];
  var _d = useState(false),
    isSearchActive = _d[0],
    setIsSearchActive = _d[1];
  var shouldShowColumns = !!(main === null || main === void 0 ? void 0 : main.length) && openMenuIndex !== null;
  var isLarge = useGreaterThan('s');
  useEffect(function () {
    if (shouldCloseMenu) {
      closeMenu();
    }
  }, [shouldCloseMenu]);
  /**
   * Close the menu.
   */
  var closeMenu = function () {
    setOpenMenuIndex(null);
    setIsSearchActive(false);
  };
  /**
   * Start the timer to hide the menu after a specified delay.
   */
  var startHideMenu = function () {
    setHoverTimeout(window.setTimeout(function () {
      setOpenMenuIndex(null);
    }, 200));
  };
  /**
   * Cancel the hiding of the menu by clearing the timeout.
   */
  var cancelHideMenu = function () {
    if (hoverTimeout !== undefined) {
      clearTimeout(hoverTimeout);
    }
  };
  /**
   * Show the menu columns for the given index and cancel any ongoing hiding process.
   *
   * @param {number} index - The index of the menu item for which to show the columns.
   */
  var showColumnIndex = function (index) {
    cancelHideMenu();
    setOpenMenuIndex(index);
  };
  /**
   * Hide the menu by first canceling any ongoing hiding process and then starting a new one.
   */
  var hideMenu = function () {
    cancelHideMenu();
    startHideMenu();
  };
  return jsx(StyledNavigation, {
    onMouseLeave: hideMenu,
    children: isLarge ? jsxs(Fragment, {
      children: [jsx(NavigationTop, {
        top: top,
        hideMenu: hideMenu
      }), jsx(NavigationMain, {
        logo: logo,
        main: main,
        isSearchActive: isSearchActive,
        setOpenMenuIndex: setOpenMenuIndex,
        showColumnIndex: showColumnIndex,
        openMenuIndex: openMenuIndex,
        setIsSearchActive: setIsSearchActive,
        search: search
      }), jsx(NavigationColumns, {
        main: main,
        shouldShowColumns: shouldShowColumns,
        openMenuIndex: openMenuIndex
      })]
    }) : jsx(NavigationMobile, {
      isSearchActive: isSearchActive,
      logo: logo,
      main: main,
      top: top,
      setIsSearchActive: setIsSearchActive,
      search: search
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3;

export { Navigation };
//# sourceMappingURL=Navigation.js.map
